import React from 'react';
import { getRecentlyViewedProduct } from '@core_modules/theme/services/graphql';
import ProductItem from '@plugin_productitem';
import ContainerScroll from '@common/ContainerScroll';
import ProductListSkeleton from '@plugin_productlist/components/ProductListSkeleton';
import cx from 'classnames';
import { getLoginInfo } from '@helper_auth';
import { getCookiesSingle } from '@helper_cookies';
import { visitorIdCookie } from '@config';

const RecentlyViewed = (props) => {
    const { storeConfig, t } = props;
    const [getProduct, { data, loading }] = getRecentlyViewedProduct();
    const isLogin = getLoginInfo();

    const productProps = {
        className: cx('carousel-item !min-w-[138px] tablet:!min-w-[230px] desktop:!min-w-[288px] rounded-none',
            'shadow-none border-none desktop:hover:shadow-none flex-shrink-0 !basis-[160px] !tablet:basis-[230px]',
            '!desktop:basis-[288px] !h-[initial] desktop:!min-w-[calc(100%/4-0.75rem)] tablet:!min-w-[calc(100%/3-0.5rem)]',
            'mobile:!min-w-[calc(100%/2-0.2rem)]'),
        enableImage: true,
        enablePrice: true,
        enableProductCompare: true,
        enableProductName: true,
        enableQuickView: true,
        enableRating: true,
        enableWishlist: true,
        imageProps: {
            className: 'product-image !w-full !h-full',
            classContainer: 'product-image-container !w-full !h-full',
        },
        storeConfig,
    };

    const visitor_id = getCookiesSingle(visitorIdCookie);
    const page_size = parseInt(storeConfig?.display_recently_viewed || '10', 10);

    React.useEffect(() => {
        if (visitor_id || isLogin) {
            getProduct({
                variables: {
                    ...visitor_id && { visitor_id: parseInt(visitor_id, 10) },
                    page_size,
                },
            });
        }
    }, [visitor_id, isLogin]);

    if (loading) {
        return (
            <>
                <ContainerScroll
                    showArrow
                    className="px-[10px]"
                    arrowSize={24}
                    arrowProps={{
                        className: cx(
                            'opacity-100',
                            '!px-0',
                        ),
                        leftNavClassName: cx(
                            'rounded-none',
                            'w-[44px]',
                            'h-[44px]',
                            'opacity-50',
                            'hover:opacity-100',
                        ),
                        rightNavClassName: cx(
                            'rounded-none',
                            'w-[44px]',
                            'h-[44px]',
                            'opacity-50',
                            'hover:opacity-100',
                        ),
                    }}
                    showDots
                >
                    <ProductListSkeleton
                        rootClassName={cx(
                            'skeleton desktop:!min-w-[calc(100%/4-0.75rem)] tablet:!min-w-[calc(100%/3-0.5rem)] ',
                            'mobile:!min-w-[calc(100%/2-0.2rem)] !p-0',
                        )}
                        length={5}
                        isGrid
                    />
                </ContainerScroll>
            </>
        );
    }

    return (
        <>
            {data?.recentViewedProducts?.items ? (
                <>
                    <div className="block w-full text-center">
                        <div className="relative inline-block">
                            <h2 class={cx('heading-title text-[40px] leading-[59px] capitalize font-bold text-center mb-[30px]',
                                'after:absolute after:w-3 after:h-3 after:bg-yellow-300 after:block after:right-[-22px] after:top-0')}
                            >
                                {t('common:recentlyViewed')}
                            </h2>
                        </div>
                    </div>
                    <ContainerScroll
                        showArrow
                        className="px-[10px]"
                        arrowSize={24}
                        arrowProps={{
                            className: cx(
                                'opacity-100',
                                '!px-0',
                            ),
                            leftNavClassName: cx(
                                'rounded-none',
                                'w-[44px]',
                                'h-[44px]',
                                'opacity-50',
                                'hover:opacity-100',
                            ),
                            rightNavClassName: cx(
                                'rounded-none',
                                'w-[44px]',
                                'h-[44px]',
                                'opacity-50',
                                'hover:opacity-100',
                            ),
                        }}
                        showDots
                    >
                        {data?.recentViewedProducts?.items?.map((product, index) => (
                            <ProductItem
                                key={index}
                                {...product}
                                {...productProps}
                                preload={false} // change to {index === 0} to preload first product image of the list
                            />
                        ))}
                    </ContainerScroll>
                </>
            ) : null}
        </>
    );
};

export default RecentlyViewed;
